<template>
  <div class="bg-secondary text-white py-2">
    <div class="container-fluid container-p-x px-3">
      <transition name="fade-up">
        <div class="font-weight-light d-flex justify-content-center" v-if="completed">
          {{ $t('sentence.newsletter_registration_success') }}
        </div>
      </transition>
      <div
        v-if="!completed"
        class="d-flex justify-content-center align-items-center flex-column flex-md-row"
      >
        <div
          class="font-secondary text-center text-lg-left mr-md-5 mb-2 mb-md-0"
        >
          {{ $t('sentence.stay_in_touch') }}
        </div>
        <form method="post" @submit.prevent="registerNewsletter">
          <div
            class="input-group d-flex justify-content-end flex-nowrap"
            v-if="!completed"
          >
            <div>
              <v-text-input
                v-model="email"
                type="email"
                placeholder="word.email"
                :required="true"
              />
            </div>

            <span class="input-group-append">
              <button
                :disabled="completed"
                type="submit"
                class="btn btn-primary"
              >
                {{ $t('phrase.register') }}
              </button>
            </span>
          </div>
          <div v-if="errors.email">
            <div
              v-for="error in errors.email"
              :key="error"
              class="text-danger"
            >
              {{ error }}
            </div>
          </div>
        </form>
      </div>
    </div>
  </div>
</template>

<script>
import api from '@/common/api';
import { mapGetters } from 'vuex';
import TextInput from '@/common/components/inputs/TextInput.vue';

export default {
  name: 'RegisterNewsletter',
  components: {
    'v-text-input': TextInput,
  },
  data() {
    return {
      completed: false,
      email: '',
      errors: {},
    };
  },
  computed: {
    ...mapGetters(['user']),
  },
  methods: {
    async registerNewsletter() {
      this.errors = {};
      const data = {};
      if (this.email) {
        data.email = this.email;
      }
      const response = await api.patch(
        'users/register-news-letter/',
        data,
      );
      if (response.status === 400) {
        this.errors = response.data;
        return;
      }

      this.completed = true;
    },
  },
  created() {
    if (!this.user.is_fake) {
      this.email = this.user.username;
    }
  },
};
</script>

<style>
input#register-newsletter-email {
  color: #000 !important;
  background: #fff !important;
  min-width: 250px;
}

@media (max-width: 767px) {
  /* Small screens */
  input#register-newsletter-email {
    min-width: 150px;
  }
}

</style>
